var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConsentBannerIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4.66675C15.12 4.66675 4.66669 15.1201 4.66669 28.0001C4.66669 40.8801 15.12 51.3334 28 51.3334C40.88 51.3334 51.3334 40.8801 51.3334 28.0001C51.3334 15.1201 40.88 4.66675 28 4.66675ZM28 30.3334C26.7167 30.3334 25.6667 29.2834 25.6667 28.0001V18.6667C25.6667 17.3834 26.7167 16.3334 28 16.3334C29.2834 16.3334 30.3334 17.3834 30.3334 18.6667V28.0001C30.3334 29.2834 29.2834 30.3334 28 30.3334ZM25.6667 35.0001V39.6667H30.3334V35.0001H25.6667Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConsentBannerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/consent-banner-icon.9d9e970edde0da0faa61487f169e4c73.svg";